import { render, staticRenderFns } from "./TeacherNotificationsCell.vue?vue&type=template&id=98a9888e&scoped=true"
import script from "./TeacherNotificationsCell.vue?vue&type=script&lang=js"
export * from "./TeacherNotificationsCell.vue?vue&type=script&lang=js"
import style0 from "./TeacherNotificationsCell.vue?vue&type=style&index=0&id=98a9888e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98a9888e",
  null
  
)

export default component.exports